import React, { useEffect, useState } from "react";
import "./util.css";
import { useGetStatsMutation } from "../../api/api";
import { DeviceIcon, TagIcon, UsersIcon, CompanyIcon, ProductIcon, ProductCategoriesIcon, SupplierIcon, RoleIcon, ReportIcon, CheckpointTypeIcon, WorkFlowIcon, SpeakerIcon, CameraAltIcon, RFIDIcon, BillBoardIcon, PersonAddIcon, PersonRemoveIcon, DomainAddIcon, DomainDisabledIcon, DoubleArrowUpIcon, DoubleArrowDownIcon } from "../../services/icons";
import { useGetDeviceStatsQuery, useGetUsersStatsQuery, useGetVMSStatsQuery } from "../../api/api";
import { useFactoryDashboardDataMutation } from "../../api/vmsSlice";
import { useThemeSetting } from "../../services/hooks";
import { useSocketContext } from "../../context/socketContext";
import { usePlantContext } from "../../context/plantContext";

const STAT_NEW_ORDER = [
  'Total Request',
  'Dock In',
  'Dock Out',
  'Total Currently In',
  'Total Today In',
  'Total Today Out',
];

const STAT_DEFAULT_ORDER = [
  'Total Request',
  'Total Today In',
  'Total Today Out',
  'Total Currently In',
];

const REST_FACTORY_STATS_ORDER = [
  'Vehicles Reported On Gate',
  'Multi Factory Vehicles',
  'Approved Vehicles Dock',
  'Approved Vehicles Parking',
  'Pending For Approval',
  'Rejected',
  'Total Gate In Count',
  'Pending For Gate In',
  'Total Vehicles Inside N I P',
  'Vehicle In Parking',
  'Total Today In',
  'Total Today Out',
  'Ongoing Operation In Factory',
  'Pending For Exit',
  'Total Gate Exit Count',
  'Pending More Than8 Hrs',
//   'Pending More Than24 Hrs',
];

export default function Genericstats({ onhandleFilter, checkpointID, filterType = "", isRecallStats, isFactoryStats = false }) {
	const STAT_DATA_ORDER = isFactoryStats?  STAT_NEW_ORDER : STAT_DEFAULT_ORDER;
	const { plantId } = usePlantContext();
	const [statData, setStatData] = useState([]);
	const [isFactoryStatsState, setIsFactoryStatsState] = useState(false);
	const [restFactoryStats, setRestFactoryStats] = useState(false);
	const [isUpArrow, setisUpArrow] = useState(false);
	const {
		socketData: { checkpointEvents },
	} = useSocketContext();
	const { orgDetail } = useThemeSetting();

	const [getStatsTrigger] = useGetStatsMutation();
	const [getFactoryDashboardData] = useFactoryDashboardDataMutation();
	

	useEffect(() => {
		// filterType comes through checkpoint component
		// checkpointID "all" comes through dashboard
		// when request is through checkpoint, we need to wait for filterType to have a value before making the API call
		let intervalId;

		const fetchStats = async () => {
			if (checkpointID != "all" && !filterType) return;

			const dailyStats =
			typeof checkpointID === "string"
				? getStatsTrigger({
					typesArr: ["All"],
					checkpointId: checkpointID,
					type: filterType,
					isCount: true,
				}).unwrap()
				: Promise.resolve(null);

			const factoryStats = isFactoryStats
			? getFactoryDashboardData({ plantId, checkpointId: checkpointID }).unwrap()
			: Promise.resolve(null);

			const allStats = [];

			const [dailyStatsResult, factoryStatsResult] = await Promise.all([
			dailyStats,
			factoryStats,
			]);

			if (dailyStatsResult && !dailyStatsResult?.error) {
			const result = Object.keys(dailyStatsResult.data).map((key) => ({
				statName: capitalizeWords(key),
				statValue:
				typeof dailyStatsResult.data[key] !== "object"
					? dailyStatsResult.data[key]
					: 0,
			}));
			allStats.push(...result);
			}

			if (factoryStatsResult && !factoryStatsResult?.error) {
			const stats = factoryStatsResult.data[0].count;
			const result = Object.keys(stats).map((key) => ({
				statName: capitalizeWords(key),
				statValue: typeof stats[key] !== "object" ? stats[key] : 0,
			}));
			allStats.push(...result);
			}

			// Filter and sort in the defined order
			const orderedStatData = STAT_DATA_ORDER
			.map((name) => allStats.find((stat) => stat.statName === name))
			.filter(Boolean);

			const orderedRestFactoryStats = REST_FACTORY_STATS_ORDER
			.map((name) => allStats.find((stat) => stat.statName === name))
			.filter(Boolean);

			setStatData(orderedStatData);
			if(isFactoryStats){
				setRestFactoryStats(orderedRestFactoryStats);
			}
			setIsFactoryStatsState(orderedRestFactoryStats.length > 0);
		};

		fetchStats();

		if (isRecallStats) {
			intervalId = setInterval(fetchStats, 90000);
		}

		return () => {
			if (intervalId) clearInterval(intervalId);
		};
		}, [checkpointID, checkpointEvents, filterType, isRecallStats]);

	useEffect(() => {
		// Check if checkpointID is an array and has elements
		if (Array.isArray(checkpointID) && checkpointID.length > 0) {
			// Create an array to hold promises for each API call
			const promises = checkpointID.map(async (ele, index) => {
				try {
					// Fetch stats data for each checkpointID
					const res = await getStatsTrigger({
						typesArr: ["All"],
						checkpointId: ele,
						isCount: true,
					}).unwrap();
					// If response is successful
					if (!res?.error) {
						const UpdatedStats = Object.keys(res?.data).map((key) => ({
							statName: capitalizeWords(key),
							statValue: typeof res?.data[key] !== "object" ? res?.data[key] : 0,
						}));
						// Return different slices of UpdatedStats based on index
						if (index === 0) {
							return UpdatedStats.slice(0, 2);
						} else {
							return UpdatedStats.slice(2, 3);
						}
					}
				} catch (err) {
					console.error(err);
					return null; // Return null for failed promises
				}
			});
			// Resolve all promises
			Promise.all(promises)
				.then((result) => {
					// Flatten the array of arrays
					const flatResult = result.flat();
					// Filter out null values
					const filteredResult = flatResult.filter((item) => item !== null);
					// Set the state with the filtered result
					setStatData(filteredResult);
				})
				.catch((err) => {
					console.error(err);
				});
		}
	}, [checkpointEvents]);

	const displayedStatData = isFactoryStats && isUpArrow && isFactoryStatsState
		? statData.filter(
			(stat) =>
				stat.statName !== 'Total Today In' && stat.statName !== 'Total Today Out'
			)
		: statData;
	return (
		<>
			<div className="genericStats-containter" style={isFactoryStatsState ? {flexWrap: 'wrap', gap : '0px 0px'} : {}}>
				{displayedStatData.length > 0 &&
					displayedStatData.map((ele, index) => {
						return (
							<div className="genericStats-tab" style={isFactoryStatsState ? {maxWidth: '180px', transform: 'scale(0.8)', marginLeft: '-20px'} : {}} key={ele.statName} onClick={(ele) => (onhandleFilter ? onhandleFilter(ele) : "")}>
								<div style={{ color: "#48494a", display : "flex", alignItems: "center", marginRight: "5px" }}>
									{logos(ele.statName, orgDetail) ? logos(ele.statName, orgDetail) : <div className="genericStats-tab-point" style={{fontSize : "40px"}}>{ele.statValue}</div>}
								</div>
								<div style={{ display : "flex", alignItems: "center", }}>
									<div>
										{logos(ele.statName, orgDetail) != null && <div className="genericStats-tab-point">{ele.statValue}</div>}
										<div className="genericStats-tab-title">{ele.statName}</div>
									</div>
								</div>
							</div>
						);
					})}	
					{isUpArrow && isFactoryStatsState && restFactoryStats.length > 0 && restFactoryStats.map((ele, index) => {
							return (
								<div className="genericStats-tab" style={{maxWidth: '180px', transform: 'scale(0.8)', marginLeft: '-20px'}} key={ele.statName} onClick={(ele) => (onhandleFilter ? onhandleFilter(ele) : "")}>
									<div style={{ color: "#48494a", display : "flex", alignItems: "center", marginRight: "5px" }}>
										{logos(ele.statName, orgDetail) ? logos(ele.statName, orgDetail) : <div className="genericStats-tab-point" style={{fontSize : "40px"}}>{ele.statValue}</div>}
									</div>
									<div style={{ display : "flex", alignItems: "center", }}>
										<div>
											{logos(ele.statName, orgDetail) != null && <div className="genericStats-tab-point">{ele.statValue}</div>}
											<div className="genericStats-tab-title">{ele.statName}</div>
										</div>
									</div>
								</div>
							);
					})}
					{isFactoryStats && isFactoryStatsState && restFactoryStats.length > 0 && <div className="genericStats-tab" style={{minWidth: '10px', transform: 'scale(0.8)', marginLeft: '-20px'}} onClick={()=> setisUpArrow(!isUpArrow)}>
						<div style={{ display : "flex", alignItems: "center", }}>
							<div>
								{isUpArrow && <DoubleArrowUpIcon style={{ fontSize: "20px", color: "#48494a" }} />}
								{!isUpArrow && <DoubleArrowDownIcon style={{ fontSize: "20px", color: "#48494a" }} />}
							</div>
						</div>
					</div>}
			</div>
		</>
	);
}

export function GenericstatsV2({ statsFor, fetchStats, plantId }) {
	const [statData, setStatData] = useState([]);
	const { data: DeviceStatsData = {}, refetch: DeviceStatsRefetch } = ["devices", "Tag"].includes(statsFor)
		? useGetDeviceStatsQuery({ statsFor: statsFor, ...(plantId && { plantIds: plantId }) }, { refetchOnMountOrArgChange: true })
		: {};
	const { data: UsersStatsData = {}, refetch: UsersRefetech } = ["users", "company", "roles"].includes(statsFor)
		? useGetUsersStatsQuery({ statsFor: statsFor }, { refetchOnMountOrArgChange: true })
		: {};
	const { data: VMSStatsData = {}, refetch: VMSStatsRefetch } = ["product", "productCategories", "supplier", "workflow", "checkpoint", "checkpointType"].includes(statsFor)
		? useGetVMSStatsQuery({ statsFor: statsFor, ...(plantId && { plantIds: plantId }) }, { refetchOnMountOrArgChange: true })
		: {};
	const { data: DeviceStats } = DeviceStatsData;
	const { data: UsersStats } = UsersStatsData;
	const { data: VMSStats } = VMSStatsData;

	useEffect(() => {
		if (DeviceStats) {
			const UpdatedStats = Object.keys(DeviceStats).map((key) => ({
				statName: capitalizeWords(key),
				statValue: typeof DeviceStats[key] !== "object" ? DeviceStats[key] : 0,
			}));
			setStatData(UpdatedStats);
		}
		if (UsersStats) {
			const UpdatedStats = Object.keys(UsersStats).map((key) => ({
				statName: capitalizeWords(key),
				statValue: typeof UsersStats[key] !== "object" ? UsersStats[key] : 0,
			}));
			setStatData(UpdatedStats);
		}
		if (VMSStats) {
			const UpdatedStats = Object.keys(VMSStats).map((key) => ({
				statName: capitalizeWords(key),
				statValue: typeof VMSStats[key] !== "object" ? VMSStats[key] : 0,
			}));
			setStatData(UpdatedStats);
		}
	}, [DeviceStats, UsersStats, VMSStats]);

	useEffect(() => {
		if (DeviceStats) {
			DeviceStatsRefetch({ statsFor: statsFor, ...(plantId && { plantIds: plantId }) });
		}
		if (UsersStats) {
			UsersRefetech({ statsFor: statsFor, ...(plantId && { plantIds: plantId }) });
		}
		if (VMSStats) {
			VMSStatsRefetch({ statsFor: statsFor, ...(plantId && { plantIds: plantId }) });
		}
	}, [fetchStats]);

	const fetchLogo = (statName) => {
		switch (statName) {
			case "Total Vehicle Request":
				return TotalTruckRequest();
			case "Total Today Vehicle In":
				return TotalTruckIn();
			case "Total Today Vehicle Out":
				return TotalTruckOut();
			case "Total Devices":
				return <DeviceIcon style={{ fontSize: "3.5em" }} />;
			case "Total Tags":
				return <TagIcon style={{ fontSize: "3.2em" }} />;
			case "Total Allocated Tags":
				return AllocatedTag();
			case "Total Users":
				return <UsersIcon style={{ fontSize: "3.3em" }} />;
			case "Active Users":
				return <PersonAddIcon style={{ fontSize: "3.3em" }} />;
			case "Inactive Users":
				return <PersonRemoveIcon style={{ fontSize: "3.3em" }} />;
			case "Total Roles":
				return <RoleIcon style={{ fontSize: "3.3em" }} />;
			case "Total Product Categories":
				return <ProductCategoriesIcon style={{ fontSize: "3.2em" }} />;
			case "Total Products":
				return <ProductIcon style={{ fontSize: "3.3em" }} />;
			case "Total Suppliers":
				return <SupplierIcon style={{ fontSize: "3.5em" }} />;
			case "Total Companies":
				return <CompanyIcon style={{ fontSize: "3.3em" }} />;
			case "Active Companies":
				return <DomainAddIcon style={{ fontSize: "3.3em" }} />;
			case "Inactive Companies":
				return <DomainDisabledIcon style={{ fontSize: "3.3em" }} />;
			case "Total Checkpoints":
				return <ReportIcon style={{ fontSize: "3.3em" }} />;
			case "Total Checkpoint Types":
				return <CheckpointTypeIcon style={{ fontSize: "3.3em" }} />;
			case "Total Workflows":
				return <WorkFlowIcon style={{ fontSize: "3.3em" }} />;
			case "Camera":
				return <CameraAltIcon style={{ fontSize: "3.3em" }} />;
			case "Led":
				return <BillBoardIcon style={{ fontSize: "3.3em" }} />;
			case "Rfid Reader":
				return <RFIDIcon style={{ fontSize: "3.3em" }} />;
			case "Speaker":
				return <SpeakerIcon style={{ fontSize: "3.3em" }} />;
			case "Workstation":
				return <WorkStation style={{ fontSize: "1.3rem" }} />;
			default:
				return <WorkFlowIcon style={{ fontSize: "3.3em" }} />;
		}
	};
	return (
		<>
			<div className="genericStats-containter">
				{statData.length > 0 &&
					statData.map((ele, index) => (
						<div className="genericStats-tab" key={ele.statName}>
							<div style={{ color: "#48494a" }}>{fetchLogo(ele.statName)}</div>
							<div>
								<div className="genericStats-tab-point">{ele.statValue}</div>
								<div className="genericStats-tab-title">{ele.statName}</div>
							</div>
						</div>
					))}
			</div>
		</>
	);
}

export function ConsolidatedStats({ orgId, deviceOptions, vmsOptions, usersOptions, type }) {
	const [statData, setStatData] = useState([]);
	const { data: DeviceStatsData = {}, refetch: DeviceStatsRefetch } = useGetDeviceStatsQuery({ statsFor: deviceOptions, orgId }, { refetchOnMountOrArgChange: true });
	const { data: UsersStatsData = {}, refetch: UsersRefetech } = useGetUsersStatsQuery({ statsFor: usersOptions, orgId }, { refetchOnMountOrArgChange: true });
	const { data: VMSStatsData = {}, refetch: VMSStatsRefetch } = useGetVMSStatsQuery({ statsFor: vmsOptions, orgId }, { refetchOnMountOrArgChange: true });

	const { data: DeviceStats } = DeviceStatsData;
	const { data: UsersStats } = UsersStatsData;
	const { data: VMSStats } = VMSStatsData;

	useEffect(() => {
		DeviceStatsRefetch({ statsFor: deviceOptions, orgId });
		UsersRefetech({ statsFor: usersOptions, orgId });
		VMSStatsRefetch({ statsFor: vmsOptions, orgId });
	}, [orgId]);

	useEffect(() => {
		let UpdatedStats = [];
		if (DeviceStats) {
			const DeviceProcessedStats = Object.keys(DeviceStats).map((key) => ({
				statName: capitalizeWords(key),
				statValue: typeof DeviceStats[key] !== "object" ? DeviceStats[key] : 0,
			}));
			UpdatedStats.push(...DeviceProcessedStats);
		}
		if (UsersStats) {
			const UserPorcessedStats = Object.keys(UsersStats).reduce(
				(acc, key) => (orgId && key === "TotalCompanies" ? acc : [...acc, { statName: capitalizeWords(key), statValue: typeof UsersStats[key] !== "object" ? UsersStats[key] : 0 }]),
				[]
			);
			UpdatedStats.push(...UserPorcessedStats);
		}
		if (VMSStats) {
			let VMSPorcessedStats = Object.keys(VMSStats).map((key) => ({
				statName: capitalizeWords(key),
				statValue: typeof VMSStats[key] !== "object" ? VMSStats[key] : 0,
			}));
			UpdatedStats.push(...VMSPorcessedStats);
		}
		setStatData(UpdatedStats);
	}, [DeviceStats, UsersStats, VMSStats]);

	const fetchLogo = (statName) => {
		switch (statName) {
			case "Total Vehicle Request":
				return TotalTruckRequest();
			case "Total Today Vehicle In":
				return TotalTruckIn();
			case "Total Today Vehicle Out":
				return TotalTruckOut();
			case "Total Devices":
				return <DeviceIcon style={{ fontSize: "3.5em" }} />;
			case "Total Tags":
				return <TagIcon style={{ fontSize: "3.2em" }} />;
			case "Total Allocated Tags":
				return AllocatedTag();
			case "Total Users":
				return <UsersIcon style={{ fontSize: "3.3em" }} />;
			case "Total Roles":
				return <RoleIcon style={{ fontSize: "3.3em" }} />;
			case "Total Product Categories":
				return <ProductCategoriesIcon style={{ fontSize: "3.2em" }} />;
			case "Total Products":
				return <ProductIcon style={{ fontSize: "3.3em" }} />;
			case "Total Suppliers":
				return <SupplierIcon style={{ fontSize: "3.5em" }} />;
			case "Total Companies":
				return <CompanyIcon style={{ fontSize: "3.3em" }} />;
			case "Total Checkpoints":
				return <ReportIcon style={{ fontSize: "3.3em" }} />;
			case "Total Checkpoint Types":
				return <CheckpointTypeIcon style={{ fontSize: "3.3em" }} />;
			case "Total Workflows":
				return <WorkFlowIcon style={{ fontSize: "3.3em" }} />;
			case "Total Trips":
				return <WorkFlowIcon style={{ fontSize: "3.3em" }} />;
			case "Total Completed Trips":
				return <WorkFlowIcon style={{ fontSize: "3.3em" }} />;
			case "Total Terminated Trips":
				return <WorkFlowIcon style={{ fontSize: "3.3em" }} />;
			case "Total Ongoing Trips":
				return <TripOngoing style={{ fontSize: "8.3em" }} />
			case "Total Cancelled Trips":
				return <CancelledTrip style={{ fontSize: '3em' }} />
			default:
				return null;
		}
	};

	let stats;
	if (!type) {
		stats = (
			<>
				<div className="genericStats-containter">
					{statData.length > 0 &&
						statData.map((ele, index) => (
							<div className="genericStats-tab tab-element" key={ele.statName}>
								<div style={{ color: "#48494a", }}>{fetchLogo(ele.statName)}</div>
								<div>
									<div className="genericStats-tab-point">{ele.statValue}</div>
									<div className="genericStats-tab-title">{ele.statName}</div>
								</div>
							</div>
						))}
				</div>
			</>
		);
	} else {
		stats = (
			<div className="scroller" data-animated="false">
				<div className="genericStats-containter scroller-inner">
					{statData.length > 0 &&
						statData.map((ele, index) => (
							<div className="genericStats-tab scroller-element" key={ele.statName}>
								<div style={{ color: "#48494a", }}>{fetchLogo(ele.statName)}</div>
								<div>
									<div className="genericStats-tab-point">{ele.statValue}</div>
									<div className="genericStats-tab-title">{ele.statName}</div>
								</div>
							</div>
						))}
					{type === "infinite-scroll" &&
						statData.length > 0 &&
						statData.map((ele, index) => (
							<div aria-hidden={true} className="genericStats-tab scroller-element" key={ele.statName + index}>
								<div style={{ color: "#48494a", }}>{fetchLogo(ele.statName)}</div>
								<div>
									<div className="genericStats-tab-point">{ele.statValue}</div>
									<div className="genericStats-tab-title">{ele.statName}</div>
								</div>
							</div>
						))}
				</div>
			</div>
		);
	}
	return stats;
}

const logos = (statName, orgDetail) => {
	return statName === "Total Request"
		? TotalTruckRequest(orgDetail?.statIcon?.total)
		: statName === "Total Today In"
			? TotalTruckIn(orgDetail?.statIcon?.todayIn)
			: statName === "Total Today Out"
				? TotalTruckOut(orgDetail?.statIcon?.todayOut)
				: statName == "Total Currently In"
					? TotalCurrentIn(orgDetail?.statIcon?.currentIn)
					: null
}

const capitalizeWords = (str) => {
	return str
		.split(" ")
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(" ")
		.split(/(?=[A-Z])/)
		.join(" ");
};

const TotalTruckRequest = (src) => {
	return src ? (
		<img src={src} height="64" width="64" />
	) : (
		<svg xmlns="http://www.w3.org/2000/svg" width="4em" height="4em" viewBox="0 0 24 24">
			<path
				fill="currentColor"
				d="M20 8h-3V4H1v13h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5M15 7h-2v7h-2V7H9v7H7V7H5v7H3V6h12zm3 11.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5M17 12V9.5h2.5l1.96 2.5z"
			/>
		</svg>
	);
};

const TotalTruckIn = (src) => {
	return src ? (
		<img src={src} height="64" width="64" />
	) : (
		<svg xmlns="http://www.w3.org/2000/svg" width="4em" height="4em" viewBox="0 0 24 24">
			<path
				fill="currentColor"
				d="M18 18.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5m1.5-9H17V12h4.46zM6 18.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5s.67 1.5 1.5 1.5M20 8l3 4v5h-2c0 1.66-1.34 3-3 3s-3-1.34-3-3H9c0 1.66-1.34 3-3 3s-3-1.34-3-3H1V6c0-1.11.89-2 2-2h14v4zM3 6v9h.76c.55-.61 1.35-1 2.24-1s1.69.39 2.24 1H15V6zm2 4.5L6.5 9L8 10.5L11.5 7L13 8.5l-5 5z"
			/>
		</svg>
	);
};

const TotalTruckOut = (src) => {
	return src ? (
		<img src={src} height="64" width="64" />
	) : (
		<svg xmlns="http://www.w3.org/2000/svg" width="4em" height="4em" viewBox="0 0 24 24">
			<path
				fill="currentColor"
				d="M18 4h-5v9H1v4h2c0 .83.3 1.53.89 2.13c.61.59 1.3.87 2.11.87s1.5-.28 2.11-.87c.59-.6.89-1.3.89-2.13h5.5c0 .83.28 1.53.88 2.13c.59.59 1.29.87 2.12.87c.8 0 1.5-.28 2.09-.87c.6-.6.91-1.3.91-2.13H23v-7zM7.08 18.07c-.28.3-.64.43-1.08.43s-.8-.13-1.08-.43s-.42-.65-.42-1.07c0-.39.14-.74.42-1.04s.64-.46 1.08-.46s.8.16 1.08.46s.42.65.42 1.04c0 .42-.14.77-.42 1.07m11.46 0c-.3.3-.65.43-1.04.43c-.42 0-.77-.13-1.07-.43S16 17.42 16 17c0-.39.13-.74.43-1.04s.65-.46 1.07-.46c.39 0 .74.16 1.04.46s.46.65.46 1.04c0 .42-.16.77-.46 1.07M15 10V6h2.06l3.33 4z"
			/>
		</svg>
	);
};

const AllocatedTag = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="3.2em" height="3.2em" viewBox="0 0 24 24">
			<path
				fill="currentColor"
				d="m21.41 11.58l-9-9C12.04 2.21 11.53 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .53.21 1.04.59 1.41l.41.4c.9-.54 1.94-.81 3-.81c3.31 0 6 2.69 6 6c0 1.06-.28 2.09-.82 3l.4.4c.37.38.89.6 1.42.6s1.04-.21 1.41-.59l7-7c.38-.37.59-.88.59-1.41s-.21-1.04-.59-1.42M5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4S7 4.67 7 5.5S6.33 7 5.5 7m3.13 7.27l-3.87 3.9l-1.35-1.37L2 18.22L4.75 21l5.28-5.32z"
			/>
		</svg>
	);
};

const TotalCurrentIn = (src) => {
	return src ? (
		<img src={src} height="64" width="64" />
	) : (
		<svg width="4em" height="4em" viewBox="0 0 612 612" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" fill="#000000" version="1.1" id="Capa_1" xmlSpace="preserve">
			<g>
				<g>
					<path
						fill="currentColor"
						d="M226.764,375.35c-28.249,0-51.078,22.91-51.078,51.16c0,28.166,22.829,51.078,51.078,51.078s51.078-22.912,51.078-51.078    C277.841,398.26,255.013,375.35,226.764,375.35z M226.764,452.049c-14.125,0-25.54-11.498-25.54-25.541    c0-14.123,11.415-25.539,25.54-25.539c14.124,0,25.539,11.416,25.539,25.539C252.302,440.551,240.888,452.049,226.764,452.049z     M612,337.561v54.541c0,13.605-11.029,24.635-24.636,24.635h-26.36c-4.763-32.684-32.929-57.812-66.927-57.812    c-33.914,0-62.082,25.129-66.845,57.812H293.625c-4.763-32.684-32.93-57.812-66.845-57.812c-33.915,0-62.082,25.129-66.844,57.812    h-33.012c-13.606,0-24.635-11.029-24.635-24.635v-54.541H612L612,337.561z M494.143,375.35c-28.249,0-51.16,22.91-51.16,51.16    c0,28.166,22.912,51.078,51.16,51.078c28.166,0,51.077-22.912,51.077-51.078C545.22,398.26,522.309,375.35,494.143,375.35z     M494.143,452.049c-14.125,0-25.539-11.498-25.539-25.541c0-14.123,11.414-25.539,25.539-25.539    c14.042,0,25.539,11.416,25.539,25.539C519.682,440.551,508.185,452.049,494.143,452.049z M602.293,282.637l-96.817-95.751    c-6.159-6.077-14.453-9.526-23.076-9.526h-48.86v-18.313c0-13.631-11.004-24.635-24.635-24.635H126.907    c-13.55,0-24.635,11.005-24.635,24.635v3.86L2.3,174.429l177.146,23.068L0,215.323l178.814,25.423L0,256.25l102.278,19.29    l-0.007,48.403h509.712v-17.985C611.983,297.171,608.452,288.796,602.293,282.637z M560.084,285.839h-93.697    c-2.135,0-3.86-1.724-3.86-3.859v-72.347c0-2.135,1.725-3.86,3.86-3.86h17.82c0.985,0,1.971,0.411,2.71,1.068l75.796,72.347    C565.257,281.569,563.532,285.839,560.084,285.839z"
					/>
				</g>
			</g>
		</svg>
	);
};
export const TripOngoing = ({ size = "2.6em" }) => {
	return (
		<svg width={size} height={size} viewBox="0 0 612 612" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" fill="#000000" version="1.1" id="Capa_1" xmlSpace="preserve">
			<g>
				<g>
					<path
						fill="currentColor"
						d="M226.764,375.35c-28.249,0-51.078,22.91-51.078,51.16c0,28.166,22.829,51.078,51.078,51.078s51.078-22.912,51.078-51.078    C277.841,398.26,255.013,375.35,226.764,375.35z M226.764,452.049c-14.125,0-25.54-11.498-25.54-25.541    c0-14.123,11.415-25.539,25.54-25.539c14.124,0,25.539,11.416,25.539,25.539C252.302,440.551,240.888,452.049,226.764,452.049z     M612,337.561v54.541c0,13.605-11.029,24.635-24.636,24.635h-26.36c-4.763-32.684-32.929-57.812-66.927-57.812    c-33.914,0-62.082,25.129-66.845,57.812H293.625c-4.763-32.684-32.93-57.812-66.845-57.812c-33.915,0-62.082,25.129-66.844,57.812    h-33.012c-13.606,0-24.635-11.029-24.635-24.635v-54.541H612L612,337.561z M494.143,375.35c-28.249,0-51.16,22.91-51.16,51.16    c0,28.166,22.912,51.078,51.16,51.078c28.166,0,51.077-22.912,51.077-51.078C545.22,398.26,522.309,375.35,494.143,375.35z     M494.143,452.049c-14.125,0-25.539-11.498-25.539-25.541c0-14.123,11.414-25.539,25.539-25.539    c14.042,0,25.539,11.416,25.539,25.539C519.682,440.551,508.185,452.049,494.143,452.049z M602.293,282.637l-96.817-95.751    c-6.159-6.077-14.453-9.526-23.076-9.526h-48.86v-18.313c0-13.631-11.004-24.635-24.635-24.635H126.907    c-13.55,0-24.635,11.005-24.635,24.635v3.86L2.3,174.429l177.146,23.068L0,215.323l178.814,25.423L0,256.25l102.278,19.29    l-0.007,48.403h509.712v-17.985C611.983,297.171,608.452,288.796,602.293,282.637z M560.084,285.839h-93.697    c-2.135,0-3.86-1.724-3.86-3.859v-72.347c0-2.135,1.725-3.86,3.86-3.86h17.82c0.985,0,1.971,0.411,2.71,1.068l75.796,72.347    C565.257,281.569,563.532,285.839,560.084,285.839z"
					/>
				</g>
			</g>
		</svg>
	)
};
export const CancelledTrip = ({ size = "2.8em" }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width={size} height={size}>
			<g id="Layer_23" data-name="Layer 23">
				<path fill="currentColor" d="M60.92,40.79,55.25,27a1,1,0,0,0-.92-.62H43.82a1,1,0,0,0-1,1V45.6H40.43V19.17a1,1,0,0,0-1-1h-5A12.73,12.73,0,0,0,9,18.17H4a1,1,0,0,0-1,1V51a1,1,0,0,0,1,1H6.68a5.44,5.44,0,0,0,10.7,0h2.39a5.44,5.44,0,0,0,10.7,0H46.65a5.44,5.44,0,0,0,10.7,0H60a1,1,0,0,0,1-1V41.17A1,1,0,0,0,60.92,40.79ZM21.71,8.42A10.75,10.75,0,1,1,11,19.17,10.76,10.76,0,0,1,21.71,8.42ZM6.68,50H5V47.6H7.76A5.48,5.48,0,0,0,6.68,50ZM12,54.4a3.44,3.44,0,0,1-.77-6.8H12.8A3.44,3.44,0,0,1,12,54.4ZM19.77,50H17.38a5.47,5.47,0,0,0-1.07-2.36h4.53A5.47,5.47,0,0,0,19.77,50Zm5.35,4.44a3.44,3.44,0,0,1-.77-6.8h1.54a3.44,3.44,0,0,1-.77,6.8ZM42.82,50H30.47a5.48,5.48,0,0,0-1.08-2.36H42.82ZM52,54.4A3.45,3.45,0,1,1,55.45,51,3.45,3.45,0,0,1,52,54.4ZM59,50H57.35a5.44,5.44,0,0,0-10.7,0H44.82V28.38h4.64V41.17a1,1,0,0,0,1,1H59Z" />
				<path d="M16.29,24.6a1,1,0,0,0,.71.29,1,1,0,0,0,.71-.29l4-4,4,4a1,1,0,0,0,.71.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.41l-4-4,4-4a1,1,0,0,0,0-1.41,1,1,0,0,0-1.42,0l-4,4-4-4a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l4,4-4,4A1,1,0,0,0,16.29,24.6Z" />
			</g>
		</svg>
	)
}

export const TripCreated = ({ size = "2.6em" }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
			<path
				fill="currentColor"
				d="M20 8h-3V4H1v13h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5M15 7h-2v7h-2V7H9v7H7V7H5v7H3V6h12zm3 11.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5s-.67 1.5-1.5 1.5M17 12V9.5h2.5l1.96 2.5z"
			/>
		</svg>
	);
};

export const TripTerminated = ({ size = "2.6em" }) => {
	return (
		<svg width={size} height={size} viewBox="0 0 126 69" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.007 52H0V35H23H34H45.5H57H69H80V0.5H92H108.5L125.5 22V52H114.993C114.728 61.4338 106.998 69 97.5 69C88.0022 69 80.2717 61.4338 80.007 52H45.993C45.7283 61.4338 37.9978 69 28.5 69C19.0022 69 11.2717 61.4338 11.007 52ZM116.5 23L106.5 9H92V23H116.5ZM38 51.5C38 56.7467 33.7467 61 28.5 61C23.2533 61 19 56.7467 19 51.5C19 46.2533 23.2533 42 28.5 42C33.7467 42 38 46.2533 38 51.5ZM97.5 61C102.747 61 107 56.7467 107 51.5C107 46.2533 102.747 42 97.5 42C92.2533 42 88 46.2533 88 51.5C88 56.7467 92.2533 61 97.5 61Z"
				fill="#3E3E3E"
			/>
		</svg>
	);
};

export const TripCompleted = ({ size = "2.6em" }) => {
	return (
		<svg width={size} height={size} viewBox="0 0 126 91" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.007 74H0V0H92V22.5H108.5L125.5 44V74H114.993C114.728 83.4338 106.998 91 97.5 91C88.0022 91 80.2717 83.4338 80.007 74H45.993C45.7283 83.4338 37.9978 91 28.5 91C19.0022 91 11.2717 83.4338 11.007 74ZM80 57V10.5H11.5V57H23H34H45.5H57H69H80ZM116.5 45L106.5 31H92V45H116.5ZM38 73.5C38 78.7467 33.7467 83 28.5 83C23.2533 83 19 78.7467 19 73.5C19 68.2533 23.2533 64 28.5 64C33.7467 64 38 68.2533 38 73.5ZM97.5 83C102.747 83 107 78.7467 107 73.5C107 68.2533 102.747 64 97.5 64C92.2533 64 88 68.2533 88 73.5C88 78.7467 92.2533 83 97.5 83Z"
				fill="#3E3E3E"
			/>
			<path d="M28 33.5L40.5 45.5L66 21" stroke="#3E3E3E" strokeWidth="10" />
		</svg>
	);
};

export const WorkStation = ({ size = "2.9em" }) => {
	return (
		<svg width={size} height={size} viewBox="0 0 288 448" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M160 320H128C123.757 320 119.687 321.686 116.686 324.686C113.686 327.687 112 331.757 112 336C112 340.243 113.686 344.313 116.686 347.314C119.687 350.314 123.757 352 128 352H160C164.243 352 168.313 350.314 171.314 347.314C174.314 344.313 176 340.243 176 336C176 331.757 174.314 327.687 171.314 324.686C168.313 321.686 164.243 320 160 320Z" fill="#3E3E3E" />
			<path d="M240 0H48C35.2739 0.0138911 23.073 5.07548 14.0742 14.0742C5.07548 23.073 0.0138911 35.2739 0 48V368C0.0304731 377.894 3.12277 387.536 8.85235 395.602C14.5819 403.669 22.6679 409.764 32 413.051V432C32 436.243 33.6857 440.313 36.6863 443.314C39.6869 446.314 43.7565 448 48 448C52.2435 448 56.3131 446.314 59.3137 443.314C62.3143 440.313 64 436.243 64 432V416H224V432C224 436.243 225.686 440.313 228.686 443.314C231.687 446.314 235.757 448 240 448C244.243 448 248.313 446.314 251.314 443.314C254.314 440.313 256 436.243 256 432V413.052C265.332 409.764 273.418 403.669 279.148 395.603C284.877 387.536 287.97 377.894 288 368V48C287.986 35.2739 282.925 23.073 273.926 14.0742C264.927 5.07548 252.726 0.0138911 240 0ZM256 368C255.994 372.242 254.307 376.308 251.308 379.308C248.308 382.307 244.242 383.995 240 384H48C43.7582 383.995 39.6918 382.307 36.6924 379.308C33.693 376.308 32.0055 372.242 32 368V48C32.0055 43.7582 33.693 39.6918 36.6924 36.6924C39.6918 33.693 43.7582 32.0055 48 32H240C244.242 32.0055 248.308 33.693 251.308 36.6924C254.307 39.6918 255.994 43.7582 256 48V368Z" fill="#3E3E3E" />
			<path d="M208 64H80C75.7565 64 71.6869 65.6857 68.6863 68.6863C65.6857 71.6869 64 75.7565 64 80C64 84.2435 65.6857 88.3131 68.6863 91.3137C71.6869 94.3143 75.7565 96 80 96H208C212.243 96 216.313 94.3143 219.314 91.3137C222.314 88.3131 224 84.2435 224 80C224 75.7565 222.314 71.6869 219.314 68.6863C216.313 65.6857 212.243 64 208 64Z" fill="#3E3E3E" />
			<path d="M208 128H80C75.7565 128 71.6869 129.686 68.6863 132.686C65.6857 135.687 64 139.757 64 144C64 148.243 65.6857 152.313 68.6863 155.314C71.6869 158.314 75.7565 160 80 160H208C212.243 160 216.313 158.314 219.314 155.314C222.314 152.313 224 148.243 224 144C224 139.757 222.314 135.687 219.314 132.686C216.313 129.686 212.243 128 208 128Z" fill="#3E3E3E" />
		</svg>
	)

}
export const Weighing = ({ size = "0.5em" }) => {
	return (
		<svg id="Layer_1" enable-background="new 0 0 160 160" viewBox="-20 -20 200 200" size={size} fill="white" xmlns="http://www.w3.org/2000/svg"><path d="m141.33 105.55h10.42c1.93 0 3.5-1.56 3.5-3.5v-24.22c0-1.39-.83-2.64-2.1-3.2l-9.7-4.27-3.16-16.14c-1.2-6.13-6.6-10.57-12.84-10.57h-13.39v5.85c0 .39-.04.78-.11 1.15h13.5c1.69 0 3.23.71 4.34 1.85h-6.97c-1.38 0-2.5 1.12-2.5 2.5v18.17c0 1.38 1.12 2.5 2.5 2.5h13.51c.19.14.4.27.62.37l7.36 3.23c-2.93.26-5.24 2.72-5.24 5.72v2.85c0 3.17 2.58 5.75 5.75 5.75h1.43v4.96h-8.39c-2.5-5.35-7.93-9.08-14.23-9.08-6.16 0-11.5 3.57-14.07 8.75v-43.85c-.98.71-2.19 1.13-3.5 1.13h-3.5v25.64h-4.94v7.07h4.94v10.34h-4.94v7h10.31c.11 4.83 2.4 9.12 5.93 11.93h-18.74v-64.48h10.94c1.93 0 3.5-1.57 3.5-3.5v-35.57c0-1.94-1.57-3.5-3.5-3.5h-35.58c-1.93 0-3.5 1.56-3.5 3.5v18.4h-60.63c-1.93 0-3.5 1.57-3.5 3.5v66.22c0 1.94 1.57 3.5 3.5 3.5h5.91c.12 4.83 2.41 9.12 5.93 11.93h-11.94c-1.93 0-3.5 1.57-3.5 3.5v13.38c0 1.93 1.57 3.5 3.5 3.5h4.83v3.88c0 4.32 3.52 7.83 7.84 7.83h4.93c4.32 0 7.83-3.51 7.83-7.83v-3.88h92.07v3.88c0 4.32 3.52 7.83 7.84 7.83h4.93c4.32 0 7.84-3.51 7.84-7.83v-3.88h4.83c1.93 0 3.5-1.57 3.5-3.5v-13.38c0-1.93-1.57-3.5-3.5-3.5h-15.79c3.53-2.81 5.82-7.1 5.93-11.93zm-14.01-34.88v-13.17h6.48l2.57 13.17zm19.5 17.92c-.41 0-.75-.34-.75-.75v-2.85c0-.41.34-.75.75-.75h1.43v4.35zm-70.84-71.16h28.58v28.57h-28.58zm16.14 35.57v65.48h-3.7v-65.48zm-80.27-13.67h57.13v10.17c0 1.93 1.57 3.5 3.5 3.5h10.94v28.14h-71.57zm3.89 59.22h-3.89v-10.34h71.57v10.34h-5.74c-2.51-5.35-7.93-9.08-14.23-9.08s-11.72 3.73-14.23 9.08h-5.02c-2.51-5.35-7.94-9.08-14.23-9.08-6.3 0-11.73 3.73-14.23 9.08zm67.68 7v11.93h-10.2c3.53-2.81 5.82-7.1 5.93-11.93zm-11.25-.36c0 .9-.14 1.77-.39 2.59-1.11 3.55-4.43 6.13-8.33 6.13-3.31 0-6.19-1.85-7.67-4.57-.67-1.23-1.05-2.65-1.05-4.15 0-4.81 3.91-8.72 8.72-8.72s8.72 3.91 8.72 8.72zm-18.49 12.29h-13.94c3.53-2.81 5.82-7.1 5.93-11.93h2.08c.11 4.83 2.4 9.12 5.93 11.93zm-14.99-12.29c0 4.81-3.91 8.72-8.72 8.72-.3 0-.6-.02-.89-.05h-.04c-.28-.03-.56-.07-.83-.13-.21-.04-.42-.1-.62-.16-.07-.02-.14-.03-.21-.05-3.55-1.11-6.14-4.42-6.14-8.33 0-4.81 3.92-8.72 8.73-8.72 3.6 0 6.71 2.2 8.03 5.33.11.24.2.49.28.75 0 .02.01.03.02.05.25.82.39 1.69.39 2.59zm-12.01 36.55c0 .46-.37.83-.83.83h-4.93c-.46 0-.84-.37-.84-.83v-3.88h6.6zm112.68 0c0 .46-.38.83-.84.83h-4.93c-.46 0-.84-.37-.84-.83v-3.88h6.61zm8.33-17.26v6.38h-135.94v-6.38zm-22.06-28.01c4.81 0 8.72 3.91 8.72 8.72 0 2.71-1.24 5.13-3.18 6.73-1.5 1.24-3.44 1.99-5.54 1.99-3.97 0-7.31-2.66-8.37-6.28-.22-.78-.35-1.59-.35-2.44 0-4.81 3.91-8.72 8.72-8.72z" /><path d="m125.629 108.23c1.677 0 3.041-1.364 3.041-3.042 0-1.677-1.364-3.041-3.041-3.041-1.678 0-3.042 1.364-3.042 3.041 0 1.678 1.364 3.042 3.042 3.042z" /><path d="m130.345 84.24c1.381 0 2.5-1.119 2.5-2.5s-1.119-2.5-2.5-2.5h-5.525c-1.381 0-2.5 1.119-2.5 2.5s1.119 2.5 2.5 2.5z" /><path d="m29.966 102.147c-1.677 0-3.042 1.364-3.042 3.041 0 1.678 1.364 3.042 3.042 3.042s3.042-1.364 3.042-3.042c0-1.677-1.365-3.041-3.042-3.041z" /><path d="m63.448 102.147c-1.677 0-3.041 1.364-3.041 3.041 0 1.678 1.364 3.042 3.041 3.042 1.678 0 3.042-1.364 3.042-3.042 0-1.677-1.365-3.041-3.042-3.041z" /><path d="m94.266 39.21c0-1.252-.591-2.358-1.496-3.092v-4.406c0-1.381-1.119-2.5-2.5-2.5s-2.5 1.119-2.5 2.5v4.407c-.904.733-1.495 1.839-1.495 3.091 0 2.203 1.792 3.996 3.995 3.996s3.996-1.792 3.996-3.996z" /><path d="m77.605 33.375c0 1.381 1.119 2.5 2.5 2.5s2.5-1.119 2.5-2.5v-.345c0-4.227 3.438-7.665 7.665-7.665s7.665 3.438 7.665 7.665v.345c0 1.381 1.119 2.5 2.5 2.5s2.5-1.119 2.5-2.5v-.345c0-6.983-5.682-12.665-12.665-12.665s-12.665 5.681-12.665 12.665z" /></svg>
	)
}

export const GateIn = ({ size = "4em" }) => {
	return (
		<svg viewBox="-15 -10 90 90" size={size} xmlns="http://www.w3.org/2000/svg"><g id="Page-1" fill="none" fill-rule="evenodd"><g id="027---Toll-Booth" fill="rgba(250, 250, 250, 1)" fill-rule="nonzero" transform="translate(0 -1)"><path id="Shape" d="m32 42v1c0 .5522847.4477153 1 1 1h22c.5522847 0 1-.4477153 1-1v-1zm17 4v1c0 .5522847.4477153 1 1 1h2c.5522847 0 1-.4477153 1-1v-1zm-16-8h-1v2h2v-1c0-.5522847-.4477153-1-1-1zm2 8v1c0 .5522847.4477153 1 1 1h2c.5522847 0 1-.4477153 1-1v-1zm-2-8h-1v2h2v-1c0-.5522847-.4477153-1-1-1zm2 8v1c0 .5522847.4477153 1 1 1h2c.5522847 0 1-.4477153 1-1v-1zm-35 4v7h56v-7zm36-2h2c.5522847 0 1-.4477153 1-1v-1h-4v1c0 .5522847.4477153 1 1 1zm-2-9c0-.5522847-.4477153-1-1-1h-1v2h2zm1 7v1c0 .5522847.4477153 1 1 1h2c.5522847 0 1-.4477153 1-1v-1zm-2-8h-1v2h2v-1c0-.5522847-.4477153-1-1-1zm2 8v1c0 .5522847.4477153 1 1 1h2c.5522847 0 1-.4477153 1-1v-1zm-2-8h-1v2h2v-1c0-.5522847-.4477153-1-1-1zm-31 6c-.55228475 0-1 .4477153-1 1v3h16v-4zm16-30h-16c-.55228475 0-1 .4477153-1 1s.44771525 1 1 1h16c.5522847 0 1-.4477153 1-1s-.4477153-1-1-1zm37.41-12.42c-.7800749-.77544719-2.0399251-.77544719-2.82 0l-3.59 3.59v5.65l6.41-6.41c.3755878-.37335029.5877672-.88042315.59-1.41.0004224-.53304458-.2119606-1.04420362-.59-1.42zm-22.41 36.42h-1v2h2v-1c0-.5522847-.4477153-1-1-1zm-10.24-3c-.4391208-.8149235-1.3800977-1.222009-2.2747027-.9840822-.894605.2379269-1.5090284 1.0586827-1.4852973 1.9840822v12h4v-12c.0000087-.3316682-.0824664-.658132-.24-.95zm-15.76-13v6h2v-2c0-.5522847.44771525-1 1-1 .5522847 0 1 .4477153 1 1v2h2v-6zm0 0v6h2v-2c0-.5522847.44771525-1 1-1 .5522847 0 1 .4477153 1 1v2h2v-6zm0 0v6h2v-2c0-.5522847.44771525-1 1-1 .5522847 0 1 .4477153 1 1v2h2v-6zm0 0v6h2v-2c0-.5522847.44771525-1 1-1 .5522847 0 1 .4477153 1 1v2h2v-6zm0 6h2v-2c0-.5522847.44771525-1 1-1 .5522847 0 1 .4477153 1 1v2h2v-6h-6zm-4-10v24h14v-24zm9 20h-4c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h4c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1zm0-4h-4c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h4c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1zm3-6c0 1.1045695-.8954305 2-2 2h-6c-1.1045695 0-2-.8954305-2-2v-6c0-1.1045695.8954305-2 2-2h6c1.1045695 0 2 .8954305 2 2zm-8-6v6h2v-2c0-.5522847.44771525-1 1-1 .5522847 0 1 .4477153 1 1v2h2v-6zm0 0v6h2v-2c0-.5522847.44771525-1 1-1 .5522847 0 1 .4477153 1 1v2h2v-6zm0 0v6h2v-2c0-.5522847.44771525-1 1-1 .5522847 0 1 .4477153 1 1v2h2v-6zm0 0v6h2v-2c0-.5522847.44771525-1 1-1 .5522847 0 1 .4477153 1 1v2h2v-6zm15 10.15c1.3941797.3669885 2.4830115 1.4558203 2.85 2.85l4.15-4.17v-5.66zm9-9v5.66l4-4v-5.64zm12-12v5.65l4-4v-5.63zm-6 6v5.66l4-4v-5.64zm-2 28.85v1c0 .5522847.4477153 1 1 1h2c.5522847 0 1-.4477153 1-1v-1zm20-8c-.5522847 0-1 .4477153-1 1v1h2v-2zm-6.12-9h-9.76l-1 3h11.81zm-9.76 0-1 3h11.81l-1-3zm13.42-3.34c-.1431502-.3959474-.5189699-.6598209-.94-.66h-14l-3.07 3.07-2.53 7.11v.82h1c1.6568542 0 3 1.3431458 3 3v1h16v-1c0-1.6568542 1.3431458-3 3-3h1v-.82zm-7.54 12.34h-2c-.5522847 0-1-.4477153-1-1s.4477153-1 1-1h2c.5522847 0 1 .4477153 1 1s-.4477153 1-1 1zm6.67-4.79c-.356417.5009293-.9352416.7959431-1.55.79h-12.24c-.6147584.0059431-1.193583-.2890707-1.55-.79-.3322438-.4793228-.4175756-1.0877757-.23-1.64l1.17-3.33c.2622386-.7332192.9514017-1.2271858 1.73-1.24h10c.7932935-.0039496 1.5027472.4930689 1.77 1.24l1.17 3.33c.1760974.5584855.0758421 1.1674435-.27 1.64zm-2.79-4.21h-9.76l-1 3h11.81z" /></g></g></svg>
	)
}

export const DefaultLocation = ({ size = "1.4em" }) => {
	return (
		<svg id="Layer_1" enable-background="new 0 0 512 512" viewBox="-60 -60 650 650" fill="rgba(250, 250, 250, 1)" size={size} xmlns="http://www.w3.org/2000/svg"><g><path d="m270.501-119.333c-.256-.273-6.188-6.48-13.768-6.869-.241-.025-.486-.037-.733-.037s-.492.013-.733.037c-7.58.389-13.512 6.596-13.768 6.869-.145.154-.145.394 0 .548.256.273 6.188 6.48 13.768 6.869.241.025.486.037.733.037s.492-.013.733-.037c7.58-.389 13.512-6.596 13.768-6.869.145-.155.145-.394 0-.548zm-28.147.273c.992-.968 4.598-4.234 9.267-5.678-1.7 1.314-2.802 3.367-2.802 5.678 0 2.309 1.101 4.362 2.8 5.676-4.664-1.445-8.272-4.709-9.265-5.676zm13.646-6.38c3.518 0 6.38 2.862 6.38 6.38s-2.862 6.38-6.38 6.38-6.38-2.862-6.38-6.38 2.862-6.38 6.38-6.38zm4.378 12.058c1.7-1.314 2.802-3.367 2.802-5.678 0-2.309-1.101-4.362-2.8-5.676 4.665 1.445 8.272 4.709 9.265 5.676-.992.969-4.598 4.234-9.267 5.678z" /><path d="m256-114.667c2.422 0 4.392-1.97 4.392-4.392s-1.97-4.392-4.392-4.392-4.392 1.97-4.392 4.392 1.97 4.392 4.392 4.392zm1.622-7.286c.522 0 .948.425.948.947s-.425.948-.948.948-.947-.425-.947-.948.424-.947.947-.947zm-1.622-.699c.283 0 .555.041.82.103-.559.292-.945.87-.945 1.543 0 .964.784 1.748 1.747 1.748.787 0 1.446-.526 1.664-1.242.195.442.307.928.307 1.441 0 1.981-1.611 3.592-3.592 3.592s-3.592-1.611-3.592-3.592 1.61-3.593 3.591-3.593z" /></g><g><path d="m414.948 148.117c-7.752-83.693-81.289-146.302-167.058-142.992-82.284 3.359-150.305 73.1-151.626 155.471-.645 39.737 10.855 79.49 35.161 121.527 10.051 17.398 20.509 34.588 30.982 51.794 32.129 52.798 65.348 107.393 86.517 168.689.868 2.514 3.184 4.25 5.842 4.377.103 0 .215.016.318.016 2.539 0 4.854-1.48 5.921-3.804 4.035-8.771 7.783-17.35 11.444-25.738 7.744-17.731 15.066-34.492 23.86-50.298 16.323-29.351 33.657-58.83 50.41-87.338 12.288-20.9 24.568-41.798 36.593-62.841 25.23-44.137 35.576-86.285 31.636-128.863zm-42.952 122.402c-12.001 20.995-24.258 41.846-36.514 62.698-16.801 28.571-34.166 58.129-50.569 87.607-9.096 16.346-16.538 33.378-24.417 51.413-1.567 3.613-3.159 7.242-4.783 10.919-21.576-56.426-52.335-106.995-82.164-156.019-10.425-17.127-20.828-34.222-30.839-51.539-23.406-40.493-34.023-76.967-33.41-114.794 1.218-75.575 63.62-139.569 139.115-142.641 2.125-.087 4.226-.135 6.327-.135 76.227 0 140.301 56.577 147.217 131.3 3.686 39.807-6.111 79.457-29.963 121.191z" /><path d="m256.31 64.003c-57.524 0-104.329 46.797-104.329 104.321s46.805 104.329 104.329 104.329 104.329-46.805 104.329-104.329-46.803-104.321-104.329-104.321zm0 195.613c-50.338 0-91.293-40.955-91.293-91.293 0-50.33 40.955-91.285 91.293-91.285s91.293 40.955 91.293 91.285c0 50.338-40.955 91.293-91.293 91.293z" /></g></svg>
	)
}